import * as nifti from 'nifti-reader-js';

export interface NiftiData {
  header: any;
  image: ArrayBuffer;
}

/**
 * 주어진 ArrayBuffer에서 nii 또는 nii.gz 파일을 읽어 NIfTI 형식의 데이터를 반환하는 함수.
 * @param buffer 파일의 ArrayBuffer (예: FileReader를 통해 읽은 데이터)
 * @returns NiftiData 객체 (헤더와 이미지 데이터 포함)
 * @throws 유효한 NIfTI 파일이 아니면 에러 발생
 */
export function parse_readNiftiFile(buffer: ArrayBuffer): NiftiData {
  // 파일이 압축된 형태(.gz)라면 압축 해제
  if (nifti.isCompressed(buffer)) {
    buffer = nifti.decompress(buffer);
  }
  
  // NIfTI 형식인지 확인
  if (nifti.isNIFTI(buffer)) {
    const header = nifti.readHeader(buffer);
    const image = nifti.readImage(header, buffer);
    return { header, image };
  } else {
    throw new Error("제공된 파일은 유효한 NIfTI 파일이 아닙니다.");
  }
}
